import * as yup from "yup";

const schema = yup.object().shape({
  email: yup.string().email().required().label("Email"),
});

export default schema;
